import { render, staticRenderFns } from "./ModalEditarCrear.vue?vue&type=template&id=54b707cf&"
import script from "./ModalEditarCrear.vue?vue&type=script&lang=js&"
export * from "./ModalEditarCrear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports